const schema = {
  clinician: {
    name: '',
    phone: '',
    email: ''
  },
  patient: {
    name: {
      first: '',
      last: ''
    },
    nhsNumber: '',
    phone: '',
    email: '',
    deliverToPatient: '',
    address: {
      line1: '',
      line2: '',
      city: '',
      county: '',
      postCode: ''
    },
    isExempt: ''
  },
  delivery: {
    address: {
      line1: '',
      line2: '',
      city: '',
      county: '',
      postCode: ''
    }
  },
  products: [
    {
      sku: '',
      desc: '',
      qty: 0
    }
  ],
  prescriptionExists: '',
  prescriber: {
    name: '',
    address: {
      line1: '',
      line2: '',
      city: '',
      county: '',
      postCode: ''
    },
    phone: '',
    email: '',
    notes: ''
  },
  files: [],
  notes: '',
  nominationConfirmation: false
}

export default schema;
